export enum ErrorMessageWidgetComponentIds {
  ErrorText = '#errorText',
  ErrorIcon = '#errorIcon',
  ErrorBox = '#errorBox',
  TopContainer = '#topContainer',
}
